import { render } from "./DropdownMultiselectInput.vue?vue&type=template&id=1012e13d&scoped=true"
import script from "./DropdownMultiselectInput.vue?vue&type=script&lang=js"
export * from "./DropdownMultiselectInput.vue?vue&type=script&lang=js"

import "./DropdownMultiselectInput.vue?vue&type=style&index=0&id=1012e13d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1012e13d"]])

export default __exports__